import React from 'react';
import withIcon from '../utilities/withIcon';

const IconBooks = () => {
  return (
    <g>
      <path d="M15.25 14.5a.75.75 0 1 1 0 1.5H.75a.75.75 0 1 1 0-1.5h14.5zM2.25 0A.75.75 0 0 1 3 .75v11.5a.75.75 0 1 1-1.5 0V.75A.75.75 0 0 1 2.25 0zm4.5 0a.75.75 0 0 1 .75.75v11.5a.75.75 0 1 1-1.5 0V.75A.75.75 0 0 1 6.75 0zm4.87.476.03.098 2.81 11.493a.75.75 0 0 1-1.426.457l-.03-.098L10.194.933A.75.75 0 0 1 11.62.476z" />
    </g>
  );
};

export default withIcon(IconBooks);
